import { defineTour } from '@lopettia/simul';

/**
 * Marketing — campaigns, landing pages, outbound sequences. Mirrors
 * docs/manuals/08-marketing.md.
 */
export const marketingTour = defineTour({
  name: 'Marketing campaign launch',
  description:
    'Spin up a campaign, attach a landing page, and enrol leads into an '
    + 'outbound sequence.',
  steps: [
    {
      id: 'mk-campaigns',
      kind: 'navigate',
      target: '[data-tour-id="nav-campaigns"]',
      toUrl: '/campaigns',
      prelude: { goto: '/dashboard' },
      message:
        '**Campaigns** group the budget, targeting, and assets for a single '
        + 'go-to-market push.',
      advanceOn: 'navigate',
    },
    {
      id: 'mk-landing',
      kind: 'navigate',
      target: '[data-tour-id="nav-landing-pages"]',
      toUrl: '/admin/landing-pages',
      message:
        '**Landing pages** are the Kairos-hosted destinations your campaign '
        + 'links point at — already wired into form capture.',
      advanceOn: 'navigate',
    },
    {
      id: 'mk-sequences',
      kind: 'navigate',
      target: '[data-tour-id="nav-sequences"]',
      toUrl: '/admin/sequences',
      message:
        '**Sequences** are the multi-step outbound flows reps enrol captured '
        + 'leads into.',
      advanceOn: 'navigate',
    },
  ],
});

export default marketingTour;
